import * as React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import CustomDialog from './CustomDialog';
import { cx } from './cx';

const useStyles = makeStyles((theme: Theme) => ({
  message: {
    color: theme.palette.text.primary,
    fontSize: 15,
    fontWeight: 600,
    lineHeight: 1.5,
    textAlign: 'center',
    // No text-selection highlight on a plain confirmation message.
    userSelect: 'none'
  },
  dangerMessage: {
    color: '#d32f2f',
    fontSize: 18,
    fontWeight: 700
  },
  bang: {
    fontSize: '1.35em',
    fontWeight: 800
  }
}));

// Renders each "!" larger than the rest of the message.
const renderDangerMessage = (message: React.ReactNode, bangClass: string): React.ReactNode => {
  if (typeof message !== 'string') {
    return message;
  }
  const segments = message.split('!');
  return segments.map((segment, index) => (
    <React.Fragment key={index}>
      {segment}
      {index < segments.length - 1 && <span className={bangClass}>!</span>}
    </React.Fragment>
  ));
};

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onClose: () => void;
  danger?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onClose,
  danger
}) => {
  const c = useStyles();

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      maxWidth="xs"
      cancelLabel={cancelLabel}
      confirmLabel={confirmLabel}
      title={title}
    >
      <Typography className={cx(c.message, danger && c.dangerMessage)}>
        {danger ? renderDangerMessage(message, c.bang) : message}
      </Typography>
    </CustomDialog>
  );
};

export default ConfirmDialog;
